import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonos } from '../data/salesData';
export function BonosSection() {
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-14" data-mp="1855ysqgw6opd">
      <div className="mx-auto max-w-6xl px-4" data-id="element-15" data-mp="13cw28rl9uqe4">
        <SectionHeading eyebrow="Siempre incluidos" data-id="element-16" data-mp="13bkz8tznhmo2">Los 6 Bonos</SectionHeading>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-17" data-mp="yektkk6pqlxh">
          {bonos.map(bono => <article key={bono.number} className="relative flex flex-col rounded-2xl border border-[var(--violet)]/40 bg-[#0d0819] p-6 transition-colors hover:border-[var(--lilac)]/70" data-id="element-18" data-mp="tdnbe7lpdrvz">
              <span className="font-display text-4xl font-extrabold text-[var(--violet)]" data-id="element-19" data-mp="fg8i2rsbwzyq">
                {bono.number}
              </span>
              <h3 className="mt-3 font-semibold text-[var(--cream)]" data-id="element-20" data-mp="2errn4vaiho34">
                {bono.title}
              </h3>
              <p className="mt-2 flex-1 text-sm text-white/65" data-id="element-21" data-mp="29urh2kdnwlc0">
                {bono.description}
              </p>
              <div className="mt-4 flex items-center gap-3" data-id="element-22" data-mp="qxr1uf7icspk">
                <span className="text-sm text-white/40 line-through" data-id="element-23" data-mp="vvajzq7btpms">
                  {bono.price}
                </span>
                <span className="rounded-full bg-[var(--lilac)] px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-black" data-id="element-24" data-mp="hwsylz4w8p81">
                  Gratis
                </span>
              </div>
            </article>)}
        </div>

        <p className="mt-10 text-center text-lg font-semibold text-[var(--cream)]" data-id="element-25" data-mp="1el8mzrw9osjk">
          Valor total bonos:{' '}
          <span className="text-white/50 line-through" data-id="element-26" data-mp="10ssrrd9lxyt7">$53.000 ARS</span>{' '}
          <span className="text-[var(--lilac-light)]" data-id="element-27" data-mp="15rvn25zscqnz">
            → Gratis con tu Sistema
          </span>
        </p>
      </div>
    </section>;
}